<template>
  <section>
    <!--工具条-->
    <!-- <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters" @submit.native.prevent>
                <el-form-item>
                    <el-input v-model="filters.LinkUrl" placeholder="标题/内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getList">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col> -->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->

    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @selection-change="selsChange"
      @current-change="selectCurrentRow"
      @row-dblclick="rowdblclick"
      style="width: 100%;"
    >
      <el-table-column
        type="index"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="bID"
        label="ID"
        width="80"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="btitle"
        label="标题"
        width="500"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="bcontent"
        label="内容"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="bstatusname"
        label="状态"
        width="110"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="bCreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width="110"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="bUpdateTime"
        label="发布时间"
        :formatter="formatCreateTime"
        width="110"
        sortable
      >
      </el-table-column>

    </el-table>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="10"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item
          label="标题"
          prop="btitle"
        >
          <el-input
            v-model="addForm.btitle"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="正文"
          prop="bcontent"
        >
          <div>
            <mavon-editor
              v-model="addForm.bcontent"
              ref="md"
              @imgAdd="$imgAdd"
              :toolbars="toolbars"
              @change="change"
              style="min-height: 600px"
            />
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="submit"
          :loading="addLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item
          label="标题"
          prop="btitle"
        >
          <el-input
            v-model="editForm.btitle"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="创建人"
              prop="bsubmitter"
            >
              <el-input
                disabled
                v-model="editForm.bsubmitter"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="创建时间"
              prop="bCreateTime"
            >
              <el-input
                disabled
                v-model="editForm.bCreateTime"
                :formatter="dateFormat2"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="正文"
          prop="bcontent"
        >
          <div>
            <mavon-editor
              v-model="editForm.bcontent"
              ref="md"
              @imgAdd="$imgAdd"
              :toolbars="toolbars"
              @change="change"
              style="min-height: 600px"
            />
          </div>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--预览界面-->
    <el-dialog
      title="预览"
      :visible.sync="readFormVisible"
      v-model="readFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="readForm"
        label-width="80px"
        ref="readForm"
      >
        <el-form-item
          label="标题"
          prop="btitle"
        >
          <el-input
            disabled
            v-model="readForm.btitle"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="创建人"
              prop="bsubmitter"
            >
              <el-input
                disabled
                v-model="readForm.bsubmitter"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="创建时间"
              prop="bCreateTime"
            >
              <el-input
                disabled
                v-model="readForm.bCreateTime"
                :formatter="dateFormat2"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="正文"
          prop="bcontent"
        >
          <div>
            <mavon-editor
              v-model="readForm.bcontent"
              :subfield="false"
              :defaultOpen="'preview'"
              :toolbarsFlag="false"
              :editable="false"
              :scrollStyle="true"
              :ishljs="true"
              ref="md"
              @change="change"
              style="min-height: 600px"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

  </section>
</template>

<script>
import util from '../../../util/date'
import { getBlogListPage, removeBlog, addBlog, editBlog, getBlogDeatil, publishBlog, unPublishBlog } from '../../api/api';
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import axios from 'axios';
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
export default {
  components: { Toolbar, mavonEditor },
  data() {
    return {
      huanjing: '',
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        help: false, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: false, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      buttonList: [],
      content: '', // 输入的markdown
      // content:'# 我的祖国  ## 你的世界', // 输入的markdown
      html: '',    // 及时转的html


      filters: {
        LinkUrl: ''
      },
      users: [],
      statusList: [{ LinkUrl: '激活', value: true }, { LinkUrl: '禁用', value: false }],
      total: 0,
      page: 1,
      listLoading: false,
      currentRow: [],//列表选中列

      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      readFormVisible: false,
      editLoading: false,
      editFormRules: {
        btitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        bcategory: [
          { required: true, message: '请选择公告分类', trigger: 'blur' }
        ],
        bcontent: [
          { required: true, message: '请输入正文', trigger: 'blur' }
        ]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: '',
        LinkUrl: '',
        Name: '',
        Enabled: false,
      },
      //编辑界面数据
      readForm: {
      },

      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
        btitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        bcategory: [
          { required: true, message: '请选择公告分类', trigger: 'blur' }
        ],
        bcontent: [
          { required: true, message: '请输入正文', trigger: 'blur' }
        ]
      },
      //新增界面数据
      addForm: {
        CreateBy: '',
        CreateId: '',
        LinkUrl: '',
        Name: '',
        Enabled: '',
      }

    }
  },
  methods: {
    // 将图片上传到服务器，返回地址替换到md中
    $imgAdd(pos, $file) {

      // var upfileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/File/Upload/' : 'http://localhost:1003/api/File/Upload/';
      // var dwfileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/File/Get/' : 'http://localhost:1003/api/File/Get/';

      var upfileurl = this.huanjing == 'production' ? global.UploadPath2 : global.testUploadPath2;
      var dwfileurl = this.huanjing == 'production' ? global.DownPath2 : global.testDownPath2;

      let formdata = new FormData()
      formdata.append('file', $file)
      axios.post(upfileurl, formdata).then(res => {
        this.$refs.md.$img2Url(pos, dwfileurl + "?filename=" + res.data.response);
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // 所有操作都会被解析重新渲染
    change(value, render) {
      // render 为 markdown 解析后的结果[html]
      this.html = render;
    },
    // 提交
    submit() {
      var a = this.content;

      console.log(this.content);
      console.log(this.html);

      this.addLoading = true;
      let para = Object.assign({}, this.addForm);

      addBlog(para).then((res) => {

        if (util.isEmt.format(res)) {
          this.addLoading = false;
          return;
        }
        if (res.data.success) {
          this.addLoading = false;
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.$refs['addForm'].resetFields();
          this.addFormVisible = false;
          this.getList();
        }
        else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }

      });
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function(row, column) {
      // return row.bcontent ? row.bcontent.substring(20) : 'N/A';
    },
    formatCreateTime: function(row, column) {
      return (!row.bCreateTime || row.bCreateTime == '') ? '' : util.formatDate.format(new Date(row.bCreateTime), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        key: this.filters.LinkUrl
      };
      this.listLoading = true;

      //NProgress.start();
      getBlogListPage(para).then((res) => {

        this.total = res.data.total;
        this.users = res.data.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        //NProgress.start();
        let para = { id: row.bID };
        removeBlog(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          //NProgress.done();
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.getList();
        });
      }).catch(() => {

      });
    },
    //发布
    handlePublish: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认发布该公告吗?', '提示', {
      }).then(() => {
        this.listLoading = true;
        // let para = 'id:'+row.bID;
        let para = { id: row.bID };

        publishBlog(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '发布公告成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.getList();
        });
      }).catch(() => {

      });
    },
    //撤销发布
    handleUnPublish: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.bstatus != 1) {
        this.$message({
          message: "只有发布后才能撤销！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认撤销发布该公告吗?', '提示', {
      }).then(() => {
        this.listLoading = true;
        let para = { id: row.bID };
        unPublishBlog(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '撤销成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.getList();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.bstatus == 1) {
        this.$message({
          message: "请撤销发布后编辑！",
          type: "error"
        });
        return;
      }
      this.editFormVisible = true;

      var para = { id: row.bID };
      getBlogDeatil(para).then(res => {
        this.editForm = Object.assign({}, res.data.data);
        this.editForm.bCreateTime = this.dateFormat2(this.editForm.bCreateTime);
        // this.content = res.data.data.bcontent;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: '',
        LinkUrl: '',
        Name: '',
        Enabled: 'true',
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editBlog(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            para.CreateTime = util.formatDate.format(new Date(), 'yyyy-MM-dd');
            para.ModifyTime = para.CreateTime;
            para.IsDeleted = false;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: '用户信息为空，先登录',
                type: 'error'
              });
              _this.$router.replace(_this.$route.query.redirect ? _this.$route.query.redirect : "/");
            }


            addModule(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getList();
              }
              else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }

            });

          });
        }
      });
    },
    //预览
    rowdblclick: function() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });
        return;
      }
      var para = { id: row.bID };

      getBlogDeatil(para).then(res => {

        this.readForm = Object.assign({}, res.data.data);
        this.readForm.bCreateTime = this.dateFormat2(this.readForm.bCreateTime);
      });
      this.readFormVisible = true;
    },
    selsChange: function(sels) {
      this.currentRow = sels;
    },
    //时间格式化2
    dateFormat2: function(row, column) {

      if (typeof row === 'undefined') return null;
      var date = new Date(row);//row 表示一行数据, updateTime 表示要格式化的字段名称
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return Y + M + D + h + m + s;
    }
  },
  mounted() {
    this.huanjing = process.env.NODE_ENV;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  }
}

</script>

<style scoped>
</style>
